import { FileCheck2, ShieldCheck, UserCheck, Zap } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

export const WhyUs = () => (
  <section id="why" className="py-20 sm:py-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="mb-14 lg:mb-16">
        <Eyebrow>03 — Why Satyam</Eyebrow>
        <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl tracking-tight text-ink max-w-2xl">
          Kyunki aapka bharosa,
          <br />
          humari <em className="italic text-gold">kamai</em> hai.
        </h2>
      </Reveal>

      <div className="grid lg:grid-cols-3 gap-5 sm:gap-6">
        <Reveal className="lg:col-span-2">
          <div
            data-testid="why-fast-approval-card"
            className="group relative h-full min-h-[280px] bg-ink text-paper rounded-[1.75rem] p-8 sm:p-10 overflow-hidden"
          >
            <div
              aria-hidden="true"
              className="absolute -bottom-20 -right-20 w-72 h-72 rounded-full bg-brand/25 blur-3xl group-hover:bg-brand/40 transition-colors duration-700"
            />
            <Zap className="w-8 h-8 text-gold" />
            <p className="mt-8 font-display text-6xl sm:text-7xl font-semibold tracking-tight">
              24–48 <span className="text-3xl sm:text-4xl text-paper/60">hrs</span>
            </p>
            <p className="mt-4 max-w-md text-paper/70 leading-relaxed">
              Superfast approval. Banks ki lambi lines aur mahino ka wait bhool
              jaiye — direct call par kaam shuru.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="relative h-full min-h-[280px] rounded-[1.75rem] overflow-hidden group">
            <img
              src="https://images.pexels.com/photos/7579138/pexels-photo-7579138.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Doorstep document collection — ghar baithe loan process"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-ink/20 to-transparent" />
            <div className="absolute bottom-0 p-8 text-paper">
              <p className="font-display text-2xl font-medium">Doorstep Documents</p>
              <p className="mt-1 text-sm text-paper/70">
                Ghar baithe document pickup — aap aayein, ya document hum aayenge.
              </p>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.05}>
          <div
            data-testid="why-approval-card"
            className="h-full bg-white border border-black/5 rounded-[1.75rem] p-8 shadow-sm hover:shadow-lg transition-shadow duration-500"
          >
            <span className="grid place-items-center w-12 h-12 rounded-2xl bg-brand-light text-brand">
              <FileCheck2 className="w-5 h-5" />
            </span>
            <p className="mt-6 font-display text-2xl font-medium text-ink">
              High Approval Ratio
            </p>
            <p className="mt-2 text-slate-600 leading-relaxed">
              First-time borrowers ke liye bhi sahi guidance aur flexible options.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div
            data-testid="why-manager-card"
            className="h-full bg-gold-light rounded-[1.75rem] p-8 hover:shadow-lg transition-shadow duration-500"
          >
            <span className="grid place-items-center w-12 h-12 rounded-2xl bg-white/80 text-gold">
              <UserCheck className="w-5 h-5" />
            </span>
            <p className="mt-6 font-display text-2xl font-medium text-ink">
              Dedicated Manager
            </p>
            <p className="mt-2 text-ink/70 leading-relaxed">
              Har customer ko personal relationship manager — call se disbursal tak.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div
            data-testid="why-transparency-card"
            className="h-full bg-white border border-black/5 rounded-[1.75rem] p-8 shadow-sm hover:shadow-lg transition-shadow duration-500"
          >
            <span className="grid place-items-center w-12 h-12 rounded-2xl bg-ink text-gold">
              <ShieldCheck className="w-5 h-5" />
            </span>
            <p className="mt-6 font-display text-2xl font-medium text-ink">
              100% Transparency
            </p>
            <p className="mt-2 text-slate-600 leading-relaxed">
              Zero hidden charges. Saare fees pehle hi clear — koi baadme surprise
              nahi.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
